'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import merge from "lodash/merge";
import { createContext, createElement, useContext, useEffect, useMemo, useState } from "react";
import { Appearance, Platform, StyleSheet } from "react-native";
export var DEFAULT_THEME = {
    button: {
        small: {
            paddingVertical: 3,
            paddingHorizontal: 15,
            fontSize: 15,
            lineHeight: 20,
            borderRadius: 22,
            iconSize: 14
        },
        normal: {
            paddingVertical: 8,
            paddingHorizontal: 20,
            fontSize: 17,
            lineHeight: 23,
            borderRadius: 22,
            iconSize: 18
        },
        large: {
            paddingVertical: 28,
            paddingHorizontal: 30,
            fontSize: 21,
            lineHeight: 20,
            borderRadius: 80,
            iconSize: 26
        }
    },
    color: {
        primary100: '#ae595b',
        primary200: '#ce6a6b',
        primary300: '#ebaca2',
        accent100: '#bed3c3',
        accent200: '#ebf1ed',
        accent300: '#f4f8f5',
        accentTwo100: '#008689',
        accentTwo200: '#008689',
        accentTwo300: '#008689',
        accentThree100: '#8b688d',
        accentThree200: '#8b688d',
        accentThree300: '#8b688d',
        dark: '#202e53',
        gray100: '#242226',
        gray200: '#322c3a',
        gray300: '#454154',
        gray400: '#6a6a7c',
        gray500: '#9191a3',
        gray600: '#c5c5d3',
        gray700: '#efeff4',
        gray800: '#f7f7f9',
        success: '#128918',
        warning: '#ecbf2d',
        danger: '#932a2a'
    },
    typography: {
        display: {
            size: 28,
            lineHeight: 35,
            weight: 'semibold',
            family: 'serif'
        },
        heading1: {
            size: 28,
            lineHeight: 38,
            weight: 'bold'
        },
        heading2: {
            size: 21,
            lineHeight: 29,
            weight: 'bold'
        },
        heading3: {
            size: 17,
            lineHeight: 23,
            weight: 'bold'
        },
        lead: {
            size: 21,
            lineHeight: 29,
            weight: 'semibold'
        },
        label: {
            size: 17,
            lineHeight: 23,
            weight: 'semibold'
        },
        body: {
            size: 17,
            lineHeight: 20
        },
        bodySmall: {
            size: 15,
            lineHeight: 20
        },
        small: {
            size: 13,
            lineHeight: 20,
            weight: 'semibold'
        }
    },
    checkbox: {
        size: 25,
        sizeSmall: 20,
        optionLabel: 'label',
        groupLabel: 'label',
        optionSpacing: 20,
        optionLabelSpacing: 15
    },
    textInput: {
        outlined: {
            paddingVertical: 11,
            marginVertical: 0,
            fontSize: 15,
            lineHeight: 20
        }
    },
    slider: {
        color: '#008689'
    }
};
var webDefault = merge({}, DEFAULT_THEME, {
    typography: {
        body: {
            size: 15,
            lineHeight: 20
        },
        label: {
            size: 15,
            lineHeight: 20
        }
    },
    checkbox: {
        size: 20,
        groupLabel: 'label',
        optionLabel: 'body',
        optionSpacing: 10,
        optionLabelSpacing: 10
    },
    textInput: {
        outlined: {
            paddingVertical: 11,
            marginVertical: 0,
            fontSize: 15,
            lineHeight: 20
        }
    }
});
var initializedTheme = Platform.OS === 'web' ? webDefault : DEFAULT_THEME;
export function getPlatformTheme(key, overrides) {
    var base = key === 'web' ? webDefault : DEFAULT_THEME;
    return merge({}, base, overrides);
}
export function mergeTheme(toMerge) {
    return merge({}, initializedTheme, toMerge);
}
var ThemeContext = createContext(initializedTheme);
export function ThemeProvider(param) {
    var theme = param.theme, children = param.children;
    var value = useMemo(function() {
        return mergeTheme(theme);
    }, [
        theme
    ]);
    return createElement(ThemeContext.Provider, {
        value: value
    }, children);
}
export function useSystemColorScheme() {
    var _useState = _sliced_to_array(useState(Appearance.getColorScheme()), 2), scheme = _useState[0], setScheme = _useState[1];
    useEffect(function() {
        var listener = Appearance.addChangeListener(function(preferences) {
            setScheme(preferences.colorScheme);
        });
        return function() {
            return listener.remove();
        };
    }, []);
    return scheme !== null && scheme !== void 0 ? scheme : 'light';
}
// TODO this came from AppContext flags before splitting out into separate package
var ALLOW_DARK_THEME = false;
export function useTheme() {
    var theme = useContext(ThemeContext);
    var _scheme = useSystemColorScheme();
    var scheme = ALLOW_DARK_THEME ? _scheme : 'light';
    return {
        scheme: scheme,
        Shadow: Shadow,
        theme: theme
    };
}
export function WithTheme(param) {
    var children = param.children;
    var theme = useTheme();
    return children(theme);
}
export var CHAT_PREVIEW_BORDER_RADIUS = 15;
export var Shadow = StyleSheet.create({
    none: {
        elevation: 0,
        shadowColor: 'transparent',
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowOpacity: 0,
        shadowRadius: 5
    },
    default: {
        elevation: 2,
        shadowColor: 'black',
        shadowOffset: {
            width: 0,
            height: 0
        },
        shadowOpacity: 0.3,
        shadowRadius: 5
    },
    low: {
        elevation: 2,
        shadowColor: DEFAULT_THEME.color.gray100,
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.3,
        shadowRadius: 5
    },
    medium: {
        elevation: 4,
        shadowColor: DEFAULT_THEME.color.gray100,
        shadowOffset: {
            width: 0,
            height: 1
        },
        shadowOpacity: 0.3,
        shadowRadius: 10
    },
    high: {
        elevation: 6,
        shadowColor: DEFAULT_THEME.color.gray100,
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.3,
        shadowRadius: 16
    },
    overlay: {
        elevation: 16,
        shadowColor: DEFAULT_THEME.color.gray100,
        shadowOffset: {
            width: 0,
            height: 20
        },
        shadowOpacity: 0.3,
        shadowRadius: 50
    }
});
export var card = [
    {
        backgroundColor: 'white',
        borderRadius: 16
    },
    Shadow.high
];
export var flatCard = [
    {
        backgroundColor: 'white',
        borderRadius: 20,
        paddingHorizontal: 20,
        paddingVertical: 15
    }
];
export var CardContainer = [
    {
        backgroundColor: 'white',
        padding: 20,
        borderRadius: 10
    }
];
export var ScrollContainer = [
    {
        backgroundColor: DEFAULT_THEME.color.gray800,
        padding: 20
    }
];
